const TOKEN_KEY = "cg_customer_token";

export function getCustomerToken() {
  return window.localStorage.getItem(TOKEN_KEY) || "";
}

export function saveCustomerToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token);
}

export function clearCustomerToken() {
  window.localStorage.removeItem(TOKEN_KEY);
}

export function customerHeaders() {
  const token = getCustomerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
